// src/components/LogoutButton.tsx
import React from "react";
import { useMsal } from "@azure/msal-react";

const LogoutButton: React.FC = () => {
  const { instance } = useMsal();
  const handleLogout = () => {
    instance.logout();  // sign out (will redirect by default)
  };
  return <button className="sign-out" onClick={handleLogout}>Sign Out</button>;
};

export default LogoutButton;